import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'objToString',
    standalone: false
})
export class ObjToStringPipe implements PipeTransform {

  transform(value): string {
    return JSON.stringify(value);
  }

}
